<ng-container>
  <div class="row">
    <div class="container">
      <div class="col-sm-1">
        <br />
        &nbsp;
        <span
          ><img src="./assets/images/icon/lupa.png" class="iconLupa"
        /></span>
      </div>
      <div class="col-sm-11">
        <mat-form-field appearance="standard">
          <mat-label> Buscar</mat-label>
          <input
            matInput
            (keyup)="applyFilter($event)"
            placeholder="Buscar"
            #input
            oninput="this.value = this.value.toUpperCase()"
          />
        </mat-form-field>
      </div>
    </div>
  </div>
  <br />

  <div class="row">
    <div class="container">
      <div class="col-sm-12 example-container">
        <div class="mat-elevation-z8">
          <table
            mat-table
            [dataSource]="dataSource"
            matTableExporter
            #exporter="matTableExporter"
            class="table table-striped table-bordered"
          >
            <ng-container matColumnDef="comite">
              <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                Comité
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="sectorByID(element)"
                class="letraE"
              >
                {{ element.nombre }}
              </td>
            </ng-container>

            <ng-container matColumnDef="sector">
              <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                Sector
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="sectorByID(element)"
                class="letraE"
              >
                {{ element.nombreSectorProductivo }}
              </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                Fecha
              </th>
              <td mat-cell *matCellDef="let element" class="letraE">
                {{
                  element?.fechaIntegracion
                    ? updateDate(element.fechaIntegracion)
                    : "N/A"
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="search">
              <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                Ver
              </th>
              <td
                mat-cell
                *matCellDef="let element"
                (click)="sectorByID(element)"
                class="letraE open"
              >
              <mat-icon>visibility</mat-icon>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <div *ngIf="activeEror" class="no-data">
            <p>No se encontraron registros</p>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>

  <mat-paginator
    [length]="totalElements"
    [pageSize]="pageSize"
    (page)="onPageChange($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</ng-container>
